<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Pools management</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_LANDING_PAGE_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add pool</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control"
             placeholder="Filter by name" style="padding: 11px;">

      <input type="text" [(ngModel)]="filters.values['identifier']" (ngModelChange)="onIdentifierChange()"
             class="form-control"
             placeholder="Filter by identifier" style="padding: 11px;">

      <app-dropdown-select [(ngModel)]="filters.values['typeId']" (onDropdownChange)="filters.onFilterChange()"
                           [multiple]="true" placeholder="Filter by type" class="form-control">
        @for (type of pageTypes; track type.id) {
          <app-dropdown-select-option [value]="type.id">{{ type }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>

      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()"
              title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th tableSorterHeader="identifier">Identifier</th>
          <th tableSorterHeader="type">Type</th>
          <th tableSorterHeader="mode">Mode</th>
          <th tableSorterHeader="enabled">Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let pool of pools">
          <td>{{ pool.id }}</td>
          <td>{{ pool.name }}</td>
          <td>{{ pool.identifier }}</td>
          <td>{{ pool.type }}</td>
          <td>{{ getModeText(pool) }}</td>
          <td>
            <span class="badge bg-success" *ngIf="pool.enabled">Enabled</span>
            <span class="badge bg-danger" *ngIf="!pool.enabled">Disabled</span>
          </td>
          <td>
            <a class="btn btn-outline-primary btn-sm" [routerLink]="[pool.id]"><i
              class="bi bi-pencil me-1"></i>Edit
            </a>
            <a class="btn btn-outline-secondary btn-sm ms-1" [routerLink]="['/stats/detailed']"
               [queryParams]="{poolId: pool.id}" title="Detailed statistics"><i
              class="bi bi-bar-chart"></i>
            </a>
            <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(pool)"><i
              class="bi bi-trash"></i></button>
          </td>
        </tr>
        </tbody>
      </table>

      <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
